import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { AuthenticatedTemplate, UnauthenticatedTemplate } from '@azure/msal-react';
import { TailSpin } from 'react-loader-spinner';
import { useUserContext } from '../../contexts/UserContext';

import StaffNavBarTemplate from '../../features/NavBar/templates/StaffNavBarTemplate';
import Login from '../../features/Login/pages/Login';
import PdfViewer from '../../features/PdfViewer/pages/PdfViewer/PdfViewer';

import logo from '../../assets/images/logo-white.png';

const DocumentViewer = () => {
  const appUser = useUserContext();
  const { signatureRequestId } = useParams();

  useEffect(() => {
    appUser.checkUser();
    appUser.checkToken();
  });

  return (
    <div>

      <AuthenticatedTemplate>
        {!appUser.user && (
        <div style={{
          display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh',
        }}
        >
          <TailSpin className="mx-auto" color="#00BFFF" height={200} width={200} visible={!appUser.user} />
        </div>
        )}

        {appUser.user && (
          <div style={{ height: '100vh' }}>
            <StaffNavBarTemplate pageLogo={logo} pageName="Document Viewer" />
            <PdfViewer signatureRequestId={signatureRequestId} />
          </div>
        )}
      </AuthenticatedTemplate>
      <UnauthenticatedTemplate>
        <Login />
      </UnauthenticatedTemplate>
    </div>
  );
};

export default DocumentViewer;
